export enum ActionMenuBehaviour {
  Default = 10,
  Hidden = 20,
}
